/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import { displayActionMessage } from 'helpers/utils';
import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import firebase from 'firebase/firebase';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { query, collection, where } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter
} from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import defaultAvatar from '../../../images/defaultAvatar.png';
import { CustomTable } from '../../../components/common';

const Users = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const onClickToggleBlocked = async (e, id) => {
    e.target.closest('tr').classList.toggle('item-active-waiting');
    await firebase.toggleUserBlocked(id).catch((error) => {
      console.error(error);
      displayActionMessage('errorMessage1', 'error');
    });
    e.target.closest('tr').classList.toggle('item-active-waiting');
  };

  const onDeleteUser = (e) => {
    e.target.closest('tr').classList.toggle('item-active');
  };

  const onConfirmDelete = async (e, id) => {
    await firebase
      .removeUserByAdmin(id)
      .catch(() => displayActionMessage('errorMessage1', 'error'));
    e.target.closest('tr').classList.toggle('item-active');
  };

  const onCancelDelete = (e) => {
    e.target.closest('tr').classList.toggle('item-active');
  };

  const [blockedUsers, isLoadingBlocked] = useCollection(
    query(
      collection(firebase.db, 'users'),
      where('blocked', '==', 'true'),
      where('role', '==', 'USER')
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );
  const [nonBlockedUsers, isLoadingNonBlocked] = useCollection(
    query(
      collection(firebase.db, 'users'),
      where('blocked', '==', 'false'),
      where('role', '==', 'USER')
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const [dataBlocked, setDataBlocked] = useState([]);
  const [dataNonBlocked, setDataNonBlocked] = useState([]);

  const dataFetch = (snapshot) => {
    const rows = [];
    snapshot.docs.map((user) =>
      rows.push({
        col1: (
          <div className="grid-admin item-img-wrapper">
            <ImageLoader
              alt={user.data().fullname}
              className="item-img"
              src={user.data().avatar || defaultAvatar}
            />
          </div>
        ),
        col2: user.data().fullname || <Skeleton width={50} />,
        col3: user.data().email || <Skeleton width={50} />,
        col4: user.id || <Skeleton width={30} />,
        col5: new Date(user.data().dateJoined) || <Skeleton width={30} />,
        col6: (
          <div className="item-action">
            <button
              className="button button-small"
              onClick={(e) => onClickToggleBlocked(e, user.id)}
              type="button"
            >
              {t('buttonToggleUserBlock')}
            </button>
            &nbsp;
            <button
              className="button button-small button-danger"
              onClick={(e) => onDeleteUser(e)}
              type="button"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
            <div className="item-action-confirm">
              <h5>{t('productDeleteConfirm')}</h5>
              <button
                className="button button-small button-border"
                onClick={(e) => onCancelDelete(e)}
                type="button"
              >
                {t('noMessage')}
              </button>
              &nbsp;
              <button
                className="button button-small button-danger"
                onClick={(e) => onConfirmDelete(e, user.id)}
                type="button"
              >
                {t('yesMessage')}
              </button>
            </div>
          </div>
        )
      })
    );
    return rows;
  };

  useEffect(() => {
    if (!isLoadingBlocked && blockedUsers) {
      const result = dataFetch(blockedUsers);
      setDataBlocked(result);
    }
  }, [blockedUsers]);
  useEffect(() => {
    if (!isLoadingNonBlocked && nonBlockedUsers) {
      const result = dataFetch(nonBlockedUsers);
      setDataNonBlocked(result);
    }
  }, [nonBlockedUsers]);

  const columns = useMemo(
    () => [
      {
        Header: 'Avatar',
        accessor: 'col1',
        disableSortBy: true
      },
      {
        Header: t('signUpNameLabel'),
        accessor: 'col2'
      },
      {
        Header: 'Email',
        accessor: 'col3'
      },
      {
        Header: 'ID',
        accessor: 'col4'
      },
      {
        Header: t('userFieldDate'),
        accessor: 'col5',
        sortType: 'datetime'
      },
      {
        Header: '',
        accessor: 'col6',
        disableSortBy: true
      }
    ],
    []
  );

  const tableInstanceBlocked = useTable(
    { columns, data: dataBlocked, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const tableInstanceNonBlocked = useTable(
    { columns, data: dataNonBlocked, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Boundary>
      <CustomTable
        tableInstance={tableInstanceBlocked}
        title={t('adminUsersMessage')}
        paragraph={t('adminUsersParagraph')}
      />
      <br />
      <br />
      <CustomTable
        tableInstance={tableInstanceNonBlocked}
        title={t('adminOtherUsers')}
      />
    </Boundary>
  );
};

export default withRouter(Users);
